// extracted by mini-css-extract-plugin
export default {"marker":"styles_marker__ygfgW"};